import {applyStaticTemplate} from 'analysis-tool/AnalysisActions';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep, PipelineStepRawData} from 'pipelines/PipelineTypes';
import ConfigureStaticTemplateModal from 'pipelines/static-templates/ConfigureStaticTemplateModal';
import {StaticTemplateId} from 'pipelines/static-templates/GeneratedStaticTemplateUIShapes';
import runModal from 'ui-library/runModal';
import {withLoadingScreen} from 'util/Promises';
import {JSONValue} from 'util/Types';

import {STATIC_TEMPLATE_UI_SHAPES} from './GeneratedStaticTemplateUIShapes';

interface DataFrameReference {
  step: PipelineStep;
  stepDataName: string;
  rawDataIndex: number;
}

export default function configureAndApplyStaticTemplate(
  staticTemplateId: StaticTemplateId,
  pipelineId: string,
  dataFrameReferences: Array<DataFrameReference>,
  handleNewSteps: (newSteps: Array<PipelineStep>) => void
): void {
  const inputDataFrames = dataFrameReferences.map(
    (dataFrameReference) =>
      dataFrameReference.step.outputStepDatas.find(
        (outputStepData) => outputStepData.name === dataFrameReference.stepDataName
      )!.rawDatas[dataFrameReference.rawDataIndex]
  ) as Array<PipelineStepRawData<PipelineStepDataKind.DATASET>>;
  const inputReferences = dataFrameReferences.map((dataFrameReference) => ({
    fromStepId: dataFrameReference.step.id,
    fromStepDataName: dataFrameReference.stepDataName,
    fromStepDataIndex: dataFrameReference.rawDataIndex,
  }));

  runModal(ConfigureStaticTemplateModal, {
    inputDataFrames,
    onRequestSubmit: async (config: Record<string, JSONValue>) => {
      const newSteps = await withLoadingScreen(
        applyStaticTemplate(pipelineId, {
          staticTemplateId,
          variableValues: config,
          inputReferences,
        }),
        `Initializing ${STATIC_TEMPLATE_UI_SHAPES[staticTemplateId].name}...`
      );

      handleNewSteps(newSteps);
    },
    staticTemplateId,
  });
}
